export const TOKEN_INVALID_ERROR_CODE_REGEX = /^(\d{2})-100-0008-(\d{3})$/;
export const USER_EMAIL_NOT_VERIFIED = '20-100-0001-004';
export const ONLY_STUDENT_HAVE_AUTH = '20-100-0002-000';
export const ONLY_TUTOR_HAVE_AUTH = '20-100-0003-000';
export const TOKEN_AMOUNT_EXCEED = '20-100-0008-010';
export const HAS_SUBSCRIPTION_PLAN = '20-200-0059-001';
export const INVALID_WORD = '20-200-0069-002';
export const NOW_TV_SUBSCRIPTION_INVALID = '20-200-0011-000';



// WEBPACK FOOTER //
// ./app/constants/errorCode.js